import { render, staticRenderFns } from "./ChatMessageTextBox.vue?vue&type=template&id=3645c3c4&"
import script from "./ChatMessageTextBox.vue?vue&type=script&lang=js&"
export * from "./ChatMessageTextBox.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageTextBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports